module.exports = __webpack_public_path__ + "static/dots-cd0dfa298041c868ca1cd53162f026aa.png";